import { render } from "./PageEnd.vue?vue&type=template&id=50963686&scoped=true"
import script from "./PageEnd.vue?vue&type=script&lang=js"
export * from "./PageEnd.vue?vue&type=script&lang=js"

import "./PageEnd.vue?vue&type=style&index=0&id=50963686&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50963686"]])

export default __exports__